import { getPlatform } from '@utils'
import axios from 'axios'
import env from '../env'
const { isWeixin, isWeixinMiniProgram, isAlipay } = getPlatform()
const { BRANDID } = Config

/** 会员相关API */
export default class MemberApi {
  /** 发送验证码 */
  static async sendCode (params: any) {
    const Url: string = `${env.MEMBER}/member/sendCaptcha`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  /** 登陆 */
  static async login (params: any) {
    const Url: string = `${env.MEMBER}/member/login`
    // @TODO source 以后外部传入
    const res: any = await axios.post(Url, {
      ...params,
      source: 'mobile',
    })
    return res.error ? res : res.result
  }
  /** 谷歌登陆 */
  static async ggLogin (params: any) {
    const Url: string = `${env.MEMBER}/login/google`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  static async ggAuthLogin (params: any) {
    const Url: string = `${env.MEMBER}/login/googleAuth`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  /** faceBook登陆 */
  static async fbLogin (params: any) {
    const Url: string = `${env.MEMBER}/login/facebook`
    // @TODO source 以后外部传入
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  /** 会员合并 */
  static async merge (params: any) {
    if (isAlipay) {
      params.channle = 'alipay'
    } else if (isWeixinMiniProgram) {
      params.channle = 'wechatminiapp'
    } else if (isWeixin) {
      params.channle = 'wechat'
    }
    const Url: string = `${env.MEMBER}/member/merge`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  /** 检测注册 */
  static async checkReg (params: any) {
    const Url: string = `${env.MEMBER}/member/checkIsRegister`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  /** 更新会员信息 */
  static async updateMemeber (params: any) {
    const Url: string = `${env.MEMBER}/member/update`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  /** 获取会员信息 */
  static async getMemeberInfo () {
    const Url: string = `${env.MEMBER}/member/detail`
    const res: any = await axios.get(Url)
    return res.error ? res : res.result
  }
  /** 更新会员微信渠道 */
  static async addWechatChannels (gOpenIds: string[]) {
    try {
      const Url: string = `${env.MEMBER}/member/addWechatChannels`
      // 与 pre.js 的 member/detail 保持一致，微信 H5 不使用 URL 中的授权 token。
      const localMemberToken = localStorage.getItem(`ls.token${window.appEnv}.${Config.BRANDID}`) || ''
      const memberToken = isWeixin && !isWeixinMiniProgram
        ? localMemberToken
        : new URLSearchParams(location.search).get('token') || localMemberToken
      const res: any = await axios.post(Url, { gOpenIds }, {
        transformRequest: [(data, headers) => {
          // 请求转换在公共拦截器之后执行，仅此接口使用小写请求头。
          headers.membertoken = memberToken
          delete headers.memberToken
          return JSON.stringify(data)
        }]
      })
      return res?.error ? undefined : res?.result
    } catch (error) {
      // 更新失败不影响授权和后续业务流程。
    }
  }
  /** 更新会员信息 */
  static async bindAccount (params: any) {
    const Url: string = `${env.MEMBER}/member/bind`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  /** 获取会员礼品卡 或会员卡 */
  static async getMemeberCards (params: any) {
    const Url: string = `${env.MEMBER}/memberCard/list`
    const res: any = await axios.get(Url, {
      params,
    })
    return res.error ? res : res.result
  }

  /** 获取会员的权益,会员卡优惠券 */
  static async getMemeberBenefits () {
    const Url: string = `${env.MEMBER}/member/benefits`
    const res: any = await axios.post(Url, { showNoPurchasedCard: true, version: '2.1.0' })
    return res.error ? res : res.result
  }

  /** 获取会员礼品卡或者会员卡详情 */
  static async getMemeberCardDetail (params: any) {
    const Url: string = `${env.MEMBER}/memberCard/detail`
    const res: any = await axios.get(Url, {
      params,
    })
    return res.error ? res : res.result
  }
  /** 绑定礼品卡 */
  static async bindCard (params: any) {
    const Url: string = `${env.MEMBER}/memberCard/bind`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  /** 获取会员优惠券 */
  static async getMemberCoupons (params: any) {
    const Url: string = `${env.MEMBER}/memberCoupon/list`
    const res: any = await axios.get(Url, {
      params,
    })
    return res.error ? res : res.result
  }
  /** 记录会员同意隐私协议 */
  static async agreeClause (params: any) {
    const Url: string = `${env.MEMBER}/member/agreeClause`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  static async acquireActiveCoupons (params: any) {
    const Url: string = `${env.MEMBER}/memberCoupon/acquireByActivity`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  static async checkGetCoupons (params: any) {
    const Url: string = `${env.MEMBER}/memberCoupon/acquiredCheck`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  static async giveCoupon (params: any) {
    const Url: string = `${env.MEMBER}/memberCoupon/memberCouponGive`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  static async getCouponGiveLog (params: any) {
    const Url: string = `${env.MEMBER}/memberCoupon/memberCouponGiveLog`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  static async cancelGiveCoupon (params: any) {
    const Url: string = `${env.MEMBER}/memberCoupon/cancelMemberCouponGive`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  static async aquireMemberGiveCoupon (params: any) {
    const Url: string = `${env.MEMBER}/memberCoupon/aquireMemberGiveCoupon`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  static async acquireByConsumeSendCoupon (params: any) {
    const Url: string = `${env.MEMBER}/memberCoupon/acquireByConsumeSendCoupon`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  /** 更改密码 */
  static async changePassword (params: any) {
    const Url: string = `${env.MEMBER}/member/changePwd`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  /** 获取卡流水 */
  static async getCardLogs (params: any) {
    const Url: string = `${env.MEMBER}/memberCard/logs`
    const res: any = await axios.get(Url, {
      params,
    })
    return res.error ? res : res.result
  }
  /** 领取会员卡 */
  static async acquireMemberCard (params: any) {
    const Url: string = `${env.MEMBER}/memberCard/acquire`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  /** 获取用户消费记录 */
  static async getConsumRecord (params: any) {
    const Url: string = `${env.REPORT}/report/jl-member-order-trans/`
    const res: any = await axios.post(Url, {
      params,
    })
    return res.error ? res : res.result
  }
  /** 创建虚拟用户 */
  static async virtual (params: any) {
    const Url: string = `${env.MEMBER}/member/virtual`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  /** 获取会员未领取优惠券 */
  static async getMemberUnacquiredCoupons (params: any) {
    const Url: string = `${env.MEMBER}/memberCoupon/unacquiredList`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  /** 获取会员领券记录 */
  static async getAcquiredLogs (params: any) {
    const Url: string = `${env.MEMBER}/memberCoupon/acquiredLogs`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  /** 领取优惠券 */
  static async acquiredCouponList (params: any) {
    const Url: string = `${env.MEMBER}/memberCoupon/acquiredByList`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  /** 赠送礼品卡 */
  static async giveCard (params: any) {
    const Url: string = `${env.MEMBER}/memberCard/give`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  /** 获取赠送记录 */
  static async getGiveLogs (params: any) {
    const Url: string = `${env.MEMBER}/memberCard/giveLogs`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  /** 获取卡关联商品 */
  static async getRedeemProduct (params: any) {
    const Url: string = `${env.MEMBER}/memberCard/listRedeemProduct`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  /** 兑换商品 */
  static async buyRedeemProduct (params: any) {
    const Url: string = `${env.MEMBER}/memberCard/redeemProduct`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  /** 获取会员下所有绑定方式 */
  static async getMemberAllBind () {
    const Url: string = `${env.MEMBER}/member/channels`
    const res: any = await axios.get(Url)
    return res.error ? res : res.result
  }
  /** 三方账号解绑 */
  static async unbindChannel (params: any) {
    const Url: string = `${env.MEMBER}/member/unbindChannel`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  /** 绑定三方账号 */
  static async bindChannel (params: any) {
    const Url: string = `${env.MEMBER}/member/bindChannel`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  /** 获取公众号赠券记录 */
  static async getOneMemberCouponGetLog (params: any) {
    const Url: string = `${env.MEMBER}/open/getOneMemberCouponGetLog`
    const res: any = await axios.get(Url, {
      params
    })
    return res.error ? res : res.result
  }
  static async acquireWechatConcernCoupon (params: any) {
    const Url: string = `${env.MEMBER}/memberCoupon/acquireWechatConcernCoupon`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  static async setWechatMiniappPhoneNumber (params: any) {
    const Url: string = `${env.MEMBER}/member/setWechatMiniappPhoneNumber`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  /** 获取集点活动 */
  static async collectPointActivity (activityId?: number) {
    const Url: string = `${env.MEMBER}/member/collectPointActivity`
    const res: any = await axios.get(Url, {
      params: {
        activityId
      },
    })
    return res.error ? res : res.result
  }
  /** 发送邮件短信 */
  static async sendEmail (params: any) {
    const Url: string = `${env.MEMBER}/open/sendEmail`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  static async sendSms (params: any) {
    const Url: string = `${env.MEMBER}/open/sendSms`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  static async getShortUrl (url: string) {
    const Url: string = `${env.JMOBILE}/shortUrl/getShortUrl`
    const res: any = await axios.post(Url, {
      originalUrl: url
    })
    return res.error ? res : res.result
  };
  // POS二维码登录
  static async qrCodeLogin (params: any) {
    const Url: string = `${env.MEMBER}/member/qrCodeLogin`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  };
  static async getActivityState () {
    const Url: string = `${env.MEMBER}/config/openState`
    const res: any = await axios.post(Url)
    return res.error ? res : res.result
  };
  // 会员地址
  static async getAddressList () {
    const Url: string = `${env.MEMBER}/memberAddress/list`
    const res: any = await axios.post(Url)
    return res.error ? res : res.result
  }
  static async createAddress (params: any) {
    const Url: string = `${env.MEMBER}/memberAddress/create`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  };
  static async updateAddress (params: any) {
    const Url: string = `${env.MEMBER}/memberAddress/update`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  };
  static async deleteAddress (id: number) {
    const Url: string = `${env.MEMBER}/memberAddress/delete`
    const res: any = await axios.post(Url, {
      memberAddressIds: [id]
    })
    return res.error ? res : res.result
  };
  static async cancelGiveGc (params: any) {
    const Url: string = `${env.MEMBER}/memberCard/cancelGive`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }

  /** 检查会员是否有权益 */
  static async checkHasBenefits (params: { mobile: string; countryCode?: number }) {
    const Url: string = `${env.MEMBER}/member/checkHasBenefits`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  static async channelDetail (params: { channel?: string; memberId: number }) {
    if (isAlipay) {
      params.channel = 'alipay'
    } else if (isWeixinMiniProgram) {
      params.channel = 'wechatminiapp'
    } else if (isWeixin) {
      params.channel = 'wechat'
    }
    const Url: string = `${env.MEMBER}/member/channelDetail`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }

  /** 兑换优惠券 */
  static async redeemCouponsbyPromoCode (params: any) {
    const Url: string = `${env.MEMBER}/memberCoupon/redeemCouponsbyPromoCode`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }

  /** 团购商城订单 */
  static async redeemProductOrders (params: any) {
    const Url: string = `${env.MEMBER}/member/redeemProductOrders`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }

  /** 设置默认会员卡 */
  static async setDefaultCard (params: any) {
    const Url: string = `${env.MEMBER}/memberCard/setDefault`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }

  /** 获取品牌会员配置信息 */
  static async getBrandConfig () {
    const Url: string = `${env.MEMBER}/config/getConfigByBrandId`
    const res: any = await axios.post(Url)
    return res.error ? res : res.result
  }

  /** 获取品牌会员配置信息 */
  static async getClauseDetail (params: { applyScope: string }) {
    const Url: string = `${env.MEMBER}/config/getClauseDetail`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }

  /** 评论 */
  static async submitComment (params: any) {
    const Url: string = `${env.MEMBER}/comment/submit`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }

  static async getCommentDetail (params: any) {
    const Url: string = `${env.MEMBER}/comment/detailAndReply`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }

  static async getCityCode (params: any) {
    const Url: string = `${env.JMOBILE}/city/getCityCode`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }

  /** 获取会员礼品卡或者会员卡订单余额 */
  static async getMemeberCardOrderBalance (params: any) {
    const Url: string = `${env.MEMBER}/memberCard/useOrdersIdGetRechargeLog`
    const res: any = await axios.post(Url, {
      ...params,
    })
    return res.error ? res : res.result
  }

  static async getWxAppInfo () {
    const Url: string = `${env.MEMBER}/config/getWxAppInfo`
    const res: any = await axios.post(Url, {
      authType: 2
    })
    return res
  }

  /**
   * 咖啡杯支付宝token登录
   * @param params
   * @returns
   */
  static async oldAlipayLogin (params: any) {
    const Url: string = `${env.MEMBER}/login/oldAlipay`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }

  /** 获取微信小程序模版ID */
  static async findWxTemplateIdByBrandId (brandId: number): Promise<{ brandTemplateId: number; templateId: number }> {
    const Url: string = `${env.MEMBER}/config/findWxTemplateIdByBrandId`
    const res: any = await axios.post(Url, { brandId })
    return res.error ? res : res.result
  }

  /** 检查壹向豆余额 */
  static async chcekEshineCoin () {
    const Url: string = `${env.JESHINECOIN}/check`
    const res: any = await axios.post(Url, { type: 'deductSms', cnt: 1 }, { headers: { 'token': localStorage.getItem(`ls.token${window.appEnv}.${BRANDID}`) || '' } })
    return res.error ? res : res.result
  }

  /** 检查微信小程序余额 */
  static async chcekWxAppMiniCoin (appId: string) {
    const Url: string = `${env.JMESSAGE}/api/wxMaAttention/getChargeUsage`
    const res: any = await axios.get(Url, {
      params: {
        appId
      },
      headers: { 'token': localStorage.getItem(`ls.token${window.appEnv}.${BRANDID}`) || '' }
    })
    return res.data
  }
}
